import { COMPARE_FLIGHT_UTM_PARAM, COMPARE_FLIGHT_UTM_VALUE } from '../constants';

/**
 * Пришёл ли пользователь по ссылке флайта сравнения ЖК (utm_source=compare_flight).
 * Читается только на клиенте: SSR-стейт содержит канонический queryString без UTM-меток.
 */
export function hasCompareFlightUtm(): boolean {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return false;
  }

  return new URLSearchParams(window.location.search).get(COMPARE_FLIGHT_UTM_PARAM) === COMPARE_FLIGHT_UTM_VALUE;
}
